export enum WORD_TYPE {
  ADJECTIVE = 'ADJECTIVE',
  KEYWORD = 'KEYWORD',
}

export class TextAnalysisResponse {
  score: number;
  text: string;
  type: WORD_TYPE;

  constructor(json: any) {
    this.score = json.score;
    this.text = json.text;
    this.type = json.type;
  }
}
